import * as THREE from "three";
import { BaseMRService } from "./BaseMRService";
import { ModelRenderer } from "../ModelRenderer";
import { MREvents } from "../MREvents";

export interface ObjectHandler {
  onClick(): void;
}

export interface MouseEventCapture {
  loc: THREE.Vector2;
  time: number;
}

export class MRUserEventer extends BaseMRService {
  div!: HTMLCanvasElement;
  mouseCapture: MouseEventCapture = { loc: new THREE.Vector2(), time: 0 };
  public mouse3DLocation: THREE.Vector3 = new THREE.Vector3();
  private raycaster = new THREE.Raycaster();

  constructor(mr: ModelRenderer) {
    super(mr);
    this.initEventListeners();
  }

  render(delta: number): void { }

  private initEventListeners() {
    this.div = this.mr.renderer.domElement;
    this.div.addEventListener('mousedown', this.onMouseDown);
    this.div.addEventListener('mouseup', this.onMouseUp);
    this.div.addEventListener('mousemove', this.onMouseMove);
  }

  private onMouseDown = (event: MouseEvent) => {
    if (event.button !== 0) {
      return;
    }
    this.mouseCapture = this.convertToScene(event);
  }

  private onMouseUp = (event: MouseEvent) => {
    if (event.button !== 0) {
      return;
    }
    const cap = this.convertToScene(event);
    const distance = this.mouseCapture.loc.distanceTo(cap.loc);
    const duration = cap.time - this.mouseCapture.time;
    if (distance < 0.1 && duration < 700) {
      const pick = this.getIntersect();
      if (pick) {
        this.mr.emitEvent(MREvents.ObjectClicked, pick.object, pick.point, pick.face, this.mouseCapture.loc);
      }
    }
  }

  private onMouseMove = (event: MouseEvent) => {
  }

  private convertToScene(event: MouseEvent): MouseEventCapture {
    const clientWidth = this.div.clientWidth;
    const clientHeight = this.div.clientHeight;
    const clientX = event.clientX - this.div.getBoundingClientRect().left;
    const clientY = event.clientY - this.div.getBoundingClientRect().top;
    // console.log('clientWidth  ', clientWidth, 'clientHeight', clientHeight);
    // console.log('event.clientX', clientX, 'event.clientY', clientY);
    const x = (clientX / clientWidth) * 2 - 1;
    const y = - (clientY / clientHeight) * 2 + 1;
    return {
      loc: new THREE.Vector2(x, y),
      time: Date.now()
    }
  }

  private getIntersect(targets?: THREE.Object3D[]): THREE.Intersection | null {
    targets = targets || this.mr.scene.children;
    this.raycaster.setFromCamera(this.mouseCapture.loc, this.mr.camera);
    let intersects = this.raycaster.intersectObjects(targets, true);
    if (intersects.length === 0) {
      return null;
    }
    const cameraPosition = new THREE.Vector3();
    this.mr.cameraControls.getPosition(cameraPosition);
    intersects = intersects.filter(i =>
      !(i.object instanceof THREE.GridHelper || i.object instanceof THREE.AxesHelper)
    );
    intersects.sort((a, b) => {
      const distanceA = a.point.distanceTo(cameraPosition);
      const distanceB = b.point.distanceTo(cameraPosition);
      return distanceA - distanceB;
    });
    const closest = intersects[0];
    return closest
  }

}